module.exports = __webpack_public_path__ + "static/img/fi.1c5f9d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fi.png
// module id = 8Czy
// module chunks = 1